const removeIndexes = (_json_predio) => {
  const json_predio = { ..._json_predio };
  delete json_predio.json_predio;
  delete json_predio.json_predio_raw;
  if (json_predio.tramites_bloquear_adeudos) {
    json_predio.tramites_bloquear_adeudos = json_predio
      .tramites_bloquear_adeudos.map((e) => e?.id || e);
  }
  const keepIndexedKeys = ['direccion', 'direccion_notificacion'];
  Object.keys(json_predio).forEach((key) => {
    if (!json_predio[key]
      || typeof json_predio[key] !== 'object'
      || Array.isArray(json_predio[key])
      || keepIndexedKeys.includes(key)
      || /fecha/.test(key)) return;
    json_predio[key] = json_predio[key].id;
  });
  return json_predio;
};

export default removeIndexes;
